"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_StructureMap_Input = exports.StructureMap_InputModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var StructureMap_InputModeKind;
(function (StructureMap_InputModeKind) {
    StructureMap_InputModeKind["_source"] = "source";
    StructureMap_InputModeKind["_target"] = "target";
})(StructureMap_InputModeKind = exports.StructureMap_InputModeKind || (exports.StructureMap_InputModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_StructureMap_Input = t.recursion('IStructureMap_Input', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        name: RTTI_id_1.RTTI_id,
        _name: RTTI_Element_1.RTTI_Element,
        type: t.string,
        _type: RTTI_Element_1.RTTI_Element,
        mode: (0, EnumType_1.createEnumType)(StructureMap_InputModeKind, 'StructureMap_InputModeKind'),
        _mode: RTTI_Element_1.RTTI_Element,
        documentation: t.string,
        _documentation: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_StructureMap_Input.js.map